import React from 'react';
import PropTypes from 'prop-types';

export default function CustomFieldType(props) {

    const customField = gd.const.customFields[props.type];

    return (
        <div className="details-item">
            <div className="label-details ui5-txt-not-important-tiny">Type:</div>
            <div className="value ui5-txt-default flex-r fl-ac">
                {customField.label}
            </div>
        </div>
    );
}

CustomFieldType.propTypes = {
    type: PropTypes.number
}